// src/components/NotFound.js
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.title}>404 - Page Not Found</h1>
            <p style={styles.text}>Sorry, the page you're looking for doesn't exist.</p>
            <Link to="/" style={styles.link}>Go to Home</Link>
        </div>
    );
};

const styles = {
    container: {
        textAlign: "center",
        padding: "100px 20px",
    },
    title: {
        fontSize: "48px",
        marginBottom: "20px",
    },
    text: {
        fontSize: "18px",
        marginBottom: "30px",
    },
    link: {
        textDecoration: "none",
        backgroundColor: "#007bff",
        color: "white",
        padding: "10px 20px",
        borderRadius: "5px",
    },
};

export default NotFound;
